<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        {{ currentPro.business_name }}
      </div>
    </template>
    <div>
      <Enable :pro="currentPro" @reload="reload"/>
      <Contact />
      <Services :pro="currentPro" />
      <Notes v-if="isPartner(currentPro)" />
      <Address />
      <Referrals :pro="currentPro" />
    </div>
  </ContentPage>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { ContentPage } from '@/components/pages'
import { Address, Contact, Enable, Notes, Referrals, Services } from './sections'
import proMixin from './proMixin'

export default {
  name: 'ProsListView',

  mixins: [proMixin],
  
  props: ['pro_id'],

  components: {
    ContentPage,
    Address, Contact, Enable, Notes, Referrals, Services
  },
  
  computed: {
    ...mapGetters('pros', ['currentPro']),
  },

  methods: {
    ...mapActions('pros', ['loadCurrent',]),

    async reload() {
      const result = await this.loadCurrent(this.pro_id)
      if (!result.ok)
        this.$router.push({ name: 'pros/list' })
    }
  },

  created() {
    this.reload()
  },
}

</script>